/**
 * Scriptures for lesson priest-2. D&C 20 and 107 aligned with scriptures.training.core3; D&C 18 from churchofjesuschrist.org.
 */
import type { Scripture } from './scriptures';

export const priest2TrainingScripturesEn: Scripture[] = [
  {
    id: 'dc-20-41-43',
    reference: 'Doctrine and Covenants 20:41–43',
    text:
      'And to confirm those who are baptized into the church, by the laying on of hands for the baptism of fire and the Holy Ghost, according to the scriptures; And to teach, expound, exhort, baptize, and watch over the church; And to confirm the church by the laying on of the hands, and the giving of the Holy Ghost;',
    verses: [
      {
        verse: 41,
        text: 'And to confirm those who are baptized into the church, by the laying on of hands for the baptism of fire and the Holy Ghost, according to the scriptures;',
      },
      {
        verse: 42,
        text: 'And to teach, expound, exhort, baptize, and watch over the church;',
      },
      {
        verse: 43,
        text: 'And to confirm the church by the laying on of the hands, and the giving of the Holy Ghost;',
      },
    ],
    context: 'Elder duties: confirmation, teaching, baptizing, and watching over the church.',
  },
  {
    id: 'dc-18-10-16',
    reference: 'Doctrine and Covenants 18:10–16',
    text:
      'Remember the worth of souls is great in the sight of God; For, behold, the Lord your Redeemer suffered death in the flesh; wherefore he suffered the pain of all men, that all men might repent and come unto him. And he hath risen again from the dead, that he might bring all men unto him, on conditions of repentance. And how great is his joy in the soul that repenteth! Wherefore, you are called to cry repentance unto this people. And if it so be that you should labor all your days in crying repentance unto this people, and bring, save it be one soul unto me, how great shall be your joy with him in the kingdom of my Father! And now, if your joy will be great with one soul that you have brought unto me into the kingdom of my Father, how great will be your joy if you should bring many souls unto me!',
    verses: [
      {
        verse: 10,
        text: 'Remember the worth of souls is great in the sight of God;',
      },
      {
        verse: 11,
        text: 'For, behold, the Lord your Redeemer suffered death in the flesh; wherefore he suffered the pain of all men, that all men might repent and come unto him.',
      },
      {
        verse: 12,
        text: 'And he hath risen again from the dead, that he might bring all men unto him, on conditions of repentance.',
      },
      {
        verse: 13,
        text: 'And how great is his joy in the soul that repenteth!',
      },
      {
        verse: 14,
        text: 'Wherefore, you are called to cry repentance unto this people.',
      },
      {
        verse: 15,
        text: 'And if it so be that you should labor all your days in crying repentance unto this people, and bring, save it be one soul unto me, how great shall be your joy with him in the kingdom of my Father!',
      },
      {
        verse: 16,
        text: 'And now, if your joy will be great with one soul that you have brought unto me into the kingdom of my Father, how great will be your joy if you should bring many souls unto me!',
      },
    ],
    context: 'The worth of souls, repentance, and the joy of bringing souls unto Christ.',
  },
  {
    id: 'dc-107-13-14',
    reference: 'Doctrine and Covenants 107:13–14',
    text:
      'The second priesthood is called the Priesthood of Aaron, because it was conferred upon Aaron and his seed, throughout all their generations. Why it is called the lesser priesthood is because it is an appendage to the greater, or the Melchizedek Priesthood, and has power in administering outward ordinances.',
    verses: [
      {
        verse: 13,
        text: 'The second priesthood is called the Priesthood of Aaron, because it was conferred upon Aaron and his seed, throughout all their generations.',
      },
      {
        verse: 14,
        text: 'Why it is called the lesser priesthood is because it is an appendage to the greater, or the Melchizedek Priesthood, and has power in administering outward ordinances.',
      },
    ],
    context: 'The Aaronic Priesthood and its relationship to the Melchizedek Priesthood.',
  },
];
